import { render, staticRenderFns } from "./SetAgentBranchModal.vue?vue&type=template&id=f9e4b678&scoped=true&"
import script from "./SetAgentBranchModal.vue?vue&type=script&lang=js&"
export * from "./SetAgentBranchModal.vue?vue&type=script&lang=js&"
import style0 from "./SetAgentBranchModal.vue?vue&type=style&index=0&id=f9e4b678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e4b678",
  null
  
)

export default component.exports